export default __webpack_public_path__ + "static/media/Adhocdate.12800070.png";